import React, { useEffect } from 'react';
import useForms from '../../../hooks/forms';
import useHttp from '../../../hooks/http';
import SpinnerHandler from '../../../hoc/SpinnerHandler/SpinnerHandler';
import AUX from '../../../hoc/AU-X/AU-X';
import CInput from '../../UI/CInput/CInput';
import CButton from '../../UI/FCButton/FCButton';
import SimpleFrame from '../../Boilerplates/SimpleFrame/SimpleFrame';
import './Forms.scss';

const FormsBoilerplate = (props) => {
  const { inputs, body, url, handleResponse, pageTitle, header, method, goBack, beforeForm, style, responseFunction } =
    props;
  const { clearAll, theForm, formIsValid, onChangeHandler, inputOnBlur, Message, setMessage, findErrorAndShow } =
    useForms();
  const { isLoading, data, error, sendRequest, clear } = useHttp();

  useEffect(() => {
    clearAll(inputs);
  }, [inputs, clearAll]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);

      if (handleResponse) {
        handleResponse(data, setMessage);
      } else {
        setMessage({
          message: data.message,
          type: data.status,
        });
      }

      clear();
    }
  }, [error, isLoading, data, clear, handleResponse, setMessage]);

  const formSubmit = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      findErrorAndShow();
      return;
    }

    let requestBody = { ...body };
    let finalUrl = url;
    let val;

    theForm.forEach((element) => {
      if (element.queryParams) {
        if (finalUrl === url) {
          finalUrl += '?';
        } else {
          finalUrl += '&';
        }

        val = element.requestValue ? element.requestValue : element.value;
        finalUrl += element.id + '=' + val;
      } else {
        if (element.single) {
          requestBody = element.value;
        } else {
          requestBody[element.id] = element.requestValue ? element.requestValue : element.value;
        }
      }

      element.AfterInputs &&
        element.AfterInputs[element.indexValue].forEach((e) => {
          requestBody[e.id] = e.requestValue ? e.requestValue : e.value;
        });
    });

    const requestMethod = method ? method : 'POST';
    const FinalRequestBody = Object.keys(requestBody).length > 0 ? JSON.stringify(requestBody) : null;

    // console.log(finalUrl, requestMethod, FinalRequestBody, header);

    sendRequest(finalUrl, requestMethod, FinalRequestBody, header, responseFunction);
  };

  return (
    <SpinnerHandler isLoading={isLoading} showError={Message}>
      <SimpleFrame style={style} NotCenter goBack={goBack}>
        {beforeForm}
        <form className='formsBoilerplate center' onSubmit={formSubmit}>
          <h2>{pageTitle}</h2>

          {theForm ? (
            theForm.map((inputs, index) => (
              <AUX key={inputs.id}>
                <CInput
                  direction={!inputs.direction && 'rtl'}
                  config={inputs.elementConfig}
                  value={inputs.value}
                  validBoxShadow={!inputs.valid && inputs.touched}
                  changed={(event) => onChangeHandler(event, index)}
                  blured={() => inputOnBlur(index)}
                />
                {inputs.AfterInputs &&
                  inputs.indexValue !== -1 &&
                  inputs.AfterInputs[inputs.indexValue].map((afterInputs, afterIndex) => (
                    <CInput
                      key={afterInputs.id}
                      direction={!afterInputs.direction && 'rtl'}
                      config={afterInputs.elementConfig}
                      value={afterInputs.value}
                      validBoxShadow={!afterInputs.valid && afterInputs.touched}
                      changed={(event) => onChangeHandler(event, index, inputs.indexValue, afterIndex)}
                      blured={() => inputOnBlur(index, inputs.indexValue, afterIndex)}
                    />
                  ))}
              </AUX>
            ))
          ) : (
            <p>این صفحه موجود نیست</p>
          )}

          {theForm && <CButton ready={formIsValid}>ثبت</CButton>}
        </form>
      </SimpleFrame>
    </SpinnerHandler>
  );
};

export default FormsBoilerplate;
